const BASE_URL = '/'
const REGISTER = `${BASE_URL}register`
const AUTH = `${BASE_URL}auth`
const PASSWORD_RECOVERY = `${BASE_URL}password-recovery`
const NEW_PASSWORD = `${BASE_URL}new-password/:key`
const HOME = `${BASE_URL}home`
const ROLES = `${BASE_URL}roles`
const DETAILS_ROLE = `${ROLES}/:roleId`
const USERS = `${BASE_URL}users`
const DETAILS_USER = `${USERS}/:userId`
const COURSES = `${BASE_URL}courses`
const DETAILS_COURSE = `${COURSES}/:courseId`
const PROGRESS_COURSE = `${DETAILS_COURSE}/progress`
const REPORTS = `${BASE_URL}reports`
const REPORT_USERS_PROGRESS = `${REPORTS}/users-progress`
const CERTIFICATE_AUTH = `${BASE_URL}autenticacao`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  REGISTER,
  AUTH,
  PASSWORD_RECOVERY,
  NEW_PASSWORD,
  HOME,
  ROLES,
  DETAILS_ROLE,
  USERS,
  DETAILS_USER,
  COURSES,
  DETAILS_COURSE,
  PROGRESS_COURSE,
  REPORTS,
  REPORT_USERS_PROGRESS,
  CERTIFICATE_AUTH,
  UNAUTHORIZED,
}
